import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

/**
 * Guard to validate that session data exists in navigation state before accessing protected routes.
 * This prevents users from accessing payment routes without proper session initialization.
 */
export const sessionIdValidationGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const navigation = router.getCurrentNavigation();

  // Check if navigation state or info contains session data
  const hasSessionData = !!(navigation?.extras?.state || navigation?.extras?.info);

  if (!hasSessionData) {
    console.warn(`[SessionGuard] Access denied to ${state.url} - No session data in navigation state`);
    // Redirect to error page or home
    router.navigate(['/404']);
    return false;
  }

  return true;
};
